// extracted by mini-css-extract-plugin
export default {"select":"FormSelect_select__CvFrr"};